import uuidv4 from 'uuid/v4';
import { authUtil } from './index';

// Keep the same ID across retries so a slow response never creates two opens.
export const recordAudiobookTabOpen = async (bookId) => {
  const eventId = uuidv4();
  const token = await authUtil.getFreshIdToken();
  const url = `${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/books/${bookId}/audiobook/tab-open`;
  for (let attempt = 0; attempt < 3; attempt += 1) {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'br-token': token },
        body: JSON.stringify({ eventId }),
      });
      if (response.ok || (response.status >= 400 && response.status < 500)) return;
    } catch {
      // A transient network failure can be retried with the same event ID.
    }
  }
};
